import { AllPage } from "@/components/analyze/all-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/alle")({
  component: AllPage,
});
